export default class User {

  constructor(data) {
    // debugger
    Object.assign(this, data);

    if (data.uid) {
      this.id = data.uid;
    } else if (data.id) {
      this.uid = data.id;
    }

    if (!this.name) {
      this.name = '';
    }


    this.language = data.language || 'default';

    this.tmpImage = null;

    // if (this.image && (this.image.cdn || this.image.storage)) {
    //   this.imageUrl = (this.image.cdn.replace('.png', '.jpg') || this.image.storage);
    // } else {
    //   this.imageUrl = null;
    // }
  }

  imageUrl() {

    // console.log('imageUrl', this.image);
    if (this.image && (this.image.cdn || this.image.storage)) {
      return (this.image.cdn || this.image.storage).replace('.png', '.jpg');
    } else if (this.tmpImage) {
      return this.tmpImage;
    } else {
      return null;
    }
  }

  static fromSnapshot(snap) {
    const user = new User(snap.val());
    user.uid = snap.key;
    return user;
  }

  // preview() {
  //   if (this.preview) {
  //     return this.preview;
  //   } else {
  //     return null;
  //   }
  // }
}
